// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1631": "1105f47b80b6","2530": "e96a97f91d26","3616": "2bd20f1d2224","4004": "66f2b799903c","5461": "4abfb4091f55","6776": "06882ca72b05","6863": "454c9f289029","8972": "d94ba7e430dc",}[chunkId] + ".css"
}